import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Grid,
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    header: {},
    content: {
        padding: 0
    },
    tableContainer: {
        maxHeight: 320
    },
    table: {
        [theme.breakpoints.down('md')]: {
            tableLayout: 'fixed'
        },
    },
    td: {
        textAlign: 'center',
        padding: '10px 2px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    tableRow: {
        '&$selected, &$selected:hover': {
            backgroundColor: theme.palette.gray.main
        }
    },
    selected: {},
    statusContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        marginLeft: theme.spacing(-1),
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const List = props => {
    const {className, onClick, data, ...rest} = props;
    const classes = useStyles(props);
    const [selectedRow, setSelectedRow] = useState(-1);

    const handleClickRow = (event) => {
        const el = event.currentTarget;

        setSelectedRow(parseInt(el.getAttribute('data-row')));

        onClick({
            dealCode: el.getAttribute('data-deal-code'),
            productNo: el.getAttribute('data-product-no')
        });
    };

    return (
        <>
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >
                <CardHeader
                    title="Best Ranking"
                    className={classes.header}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <Grid container spacing={1}>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            xs={12}
                        >
                            <TableContainer className={classes.tableContainer}>
                                <Table stickyHeader aria-label="sticky table" className={classes.table}>
                                    <colgroup>
                                        <col />
                                        <col />
                                        <col />
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell size="small" className={classes.td}>Avg. Rank</TableCell>
                                            <TableCell className={classes.td}>Product Name</TableCell>
                                            <TableCell className={classes.td}>Date</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((product, j) => (
                                            <TableRow
                                                hover
                                                key={j}
                                                data-deal-code={product.deal_cd}
                                                data-product-no={product.prd_no}
                                                data-row={j}
                                                onClick={handleClickRow}
                                                selected={selectedRow === j}
                                                classes={{selected: classes.selected}}
                                                className={classes.tableRow}
                                            >
                                                <TableCell className={classes.td}>{product.priority}</TableCell>
                                                <TableCell className={classes.td} title={product.prd_nm}>{product.prd_nm}</TableCell>
                                                <TableCell className={classes.td}>{product.extract_dt}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider/>
            </Card>
        </>
    );
};

List.propTypes = {
    className: PropTypes.string,
    data: PropTypes.array.isRequired,
    onClick: PropTypes.func
};

export default List;
